module.exports = __webpack_public_path__ + "static/media/sdlc.a52e1eca.png";